import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'

import { clearReauthRequired } from '../../redux/services/auth'
import { setGlimpseApiToken } from '../../server/store'
import queryClient from '../../queryClient'
import { logError } from '../../utils/logger'
import { withMsal } from '../MsalAuth/withMsal'

import {
  Container,
  Header,
  HeaderTitle,
  HeaderSubtitle,
  ErrorText,
  WarningIcon,
  IconContainer,
} from './style'

export const SessionExpiredBanner = ({ auth0 }) => {
  const [isReconnecting, setReconnecting] = useState(false)
  const [hasFailed, setFailed] = useState(false)

  const handleReconnect = async () => {
    setReconnecting(true)
    setFailed(false)
    try {
      const token = await auth0.getAccessTokenWithPopup()
      if (!token) throw new Error('Reconnect resolved without a token')
      setGlimpseApiToken(token)
      clearReauthRequired()
      queryClient.invalidateQueries()
    } catch (e) {
      logError(e, 'SessionExpiredBanner > handleReconnect')
      setFailed(true)
    } finally {
      setReconnecting(false)
    }
  }

  return (
    <Container data-testid="sessionExpiredBanner" role="alert">
      <Header>
        <IconContainer>
          <WarningIcon />
        </IconContainer>
        <HeaderTitle>Your session needs to be renewed</HeaderTitle>
        {hasFailed ? (
          <ErrorText>Could not renew your session. Try again.</ErrorText>
        ) : (
          <HeaderSubtitle>
            Glimpse could not renew your session in the background. Reconnect to keep working.
          </HeaderSubtitle>
        )}
        <Button
          size="small"
          variant="contained"
          disabled={isReconnecting}
          onClick={handleReconnect}
          data-testid="sessionExpiredBanner.reconnect"
        >
          Reconnect
        </Button>
      </Header>
    </Container>
  )
}

SessionExpiredBanner.propTypes = {
  auth0: PropTypes.shape({
    getAccessTokenWithPopup: PropTypes.func.isRequired,
  }).isRequired,
}

export default withMsal(SessionExpiredBanner)
